// @flow

import {useLayoutEffect} from 'react';

import {type WithRouterProps} from 'app/general/withTypedRouter';
import {useNavLinks} from 'app/general/structures/SPFrame/SPHeader/nav_links';

type Props = WithRouterProps<{||}>;

export function HomePageRedirect({router}: Props) {
  // get the first nav link
  const homeLink = useNavLinks()[0].href;

  // redirect the user to that page
  // using useLayoutEffect will avoid showing a blank page during the redirect
  useLayoutEffect(() => {
    router.replace(homeLink);
  }, []);

  return null;
}
